<template>
  <el-row class="suggest-inside" :class="getThemeInfo">
    <!--查找/替换-->
    <el-col :span="24" v-if="(getEditorRightShownInfo.column)==='first'&&status">
      <div class="title">查找/替换</div>
      <div class="content find-replacr-wrap">
        <div class="entry-word">
          <el-input placeholder="请输入内容" v-model="entryKeyword" class="input-with-select"
                    @input.native="(e) =>handleChange(e,0)">
          </el-input>
        </div>
        <div class="shown-number">
          <i class="icon el-icon-caret-left" @click='()=>handlePrev()' />
          <span class="number">{{toolNumber?number+1:toolNumber}}/{{toolNumber}}</span>
          <i class="icon el-icon-caret-right" @click='()=>handleNext()' />
        </div>
        <!--如果任务已经被提交将会禁止相应的功能-->
        <el-row class="replace-word">
          <el-col :span="16">
            <el-input placeholder="请输入内容" v-model="replaceKeyword" class="input-with-select"
                      @input.native="(e)=>handleKeyword(e)">
              <el-button slot="append" @click.native="()=>handleReplace()"
                         :disabled="isReplaceDisabled">
                替换
              </el-button>
            </el-input>
          </el-col>
          <el-col :span="7" :offset="1" class="replace-all" @click.native="()=>handleAllReplace()"
                  :disabled="isReplaceDisabled">
            全部替换
          </el-col>
        </el-row>
      </div>
    </el-col>

    <!--添加术语库-->
    <el-col :span="24" v-if="(getEditorRightShownInfo.column)==='second'">
      <div class="title">添加术语库</div>
      <div class="content team-form-wrap">
        <el-form ref="form" :model="form">
          <el-form-item prop="source"
                        :rules="[{ required: true, message: '术语不能为空', trigger: 'blur'}]">
            <el-input v-model="form.source" placeholder="请输入术语" @input="changeInput('source')" />
          </el-form-item>
          <el-form-item prop="target"
                        :rules="[{ required: true, message: '译文不能为空', trigger: 'blur'}]">
            <el-input v-model="form.target" placeholder="请输入译文" @input="changeInput('target')" />
          </el-form-item>
          <el-form-item>
            <el-row class="submit-box">
              <el-col :span="11" class="item">
                <el-button type="primary" @click="handleSubmit" size="small">添加
                </el-button>
              </el-col>
              <el-col :span="2" class="item">&nbsp;</el-col>
              <el-col :span="11" class="item">
                <el-button type="primary" @click="handleReset('form')" size="small">重置</el-button>
              </el-col>
            </el-row>
          </el-form-item>
        </el-form>
      </div>
    </el-col>

    <!--记忆库/术语库/QA错误-->
    <el-col :span="24" v-if="getEditorRightShownInfo.column==='third'">
      <div class="frangment-wrap">
        <!-- 机翻 -->
        <template v-if="getFragmentSentenceMt.length">
          <div class="frangment-wrap-item" v-for="item in getFragmentSentenceMt" :key="item.sid">
            <template v-if="item.atoms&&item.atoms.length">
              <div class="frangment-wrap-item-top">
                <div class="item-top-title">AT</div>
                <div class="item-top-insert" title="插入"
                     @click="handleInsertTargetSentence('AT',item)"></div>
              </div>
              <div class="frangment-wrap-item-content" :class="targetRightViewClass('at-target')">
                <span class="item-content-target" v-for="atomsItem in item.atoms"
                      :key="atomsItem.sid" v-html="atomsItem.data"></span>
              </div>
              <div class="frangment-wrap-item-bottom">
                <div class="item-bottom-origin at-name" :title="item.name?item.name:''">
                  来源:
                  <span class="result-text">{{item.name?item.name:''}}</span>
                </div>
              </div>
            </template>
          </div>
        </template>
        <!-- 记忆库 -->
        <template v-if="getFrangmentMemoryInfo.length">
          <div class="frangment-wrap-item" v-for="item in getFrangmentMemoryInfo" :key="item.id">
            <div class="frangment-wrap-item-top">
              <div class="item-top-title">TM</div>
              <div class="item-top-insert" title="插入"
                   @click="handleInsertTargetSentence('TM',item)"></div>
            </div>
            <div class="frangment-wrap-item-content">
              <div class="item-content-source" :class="targetRightViewClass('tm-source')"
                   v-html="item.sourceSent"></div>
              <div class="item-content-target" :class="targetRightViewClass('tm-target')"
                   v-html="item.targetSent"></div>
            </div>
            <div class="frangment-wrap-item-bottom">
              <div class="item-bottom-origin" :title="item.libName">
                来源:
                <span class="result-text">{{item.libName}}</span>
              </div>
              <div class="item-bottom-matching-degree">
                匹配度:
                <span class="result-text">{{item.similarPercent}}%</span>
              </div>
            </div>
          </div>
        </template>
        <!-- 术语库 -->
        <template v-if="getFrangmentTermInfo.length">
          <div class="frangment-wrap-item" v-for="(item,index) in getFrangmentTermInfo"
               :key="index">
            <div class="frangment-wrap-item-top">
              <div class="item-top-title">TB</div>
              <!-- 暂时去掉术语插入 -->
              <!-- <div class="item-top-insert" title="插入"
                   @click="handleInsertTargetSentence('TB',item)"></div> -->
            </div>
            <div class="frangment-wrap-item-content">
              <div class="item-content-source" :class="targetRightViewClass('tb-source')"
                   v-html="item.sourceSent"></div>
              <template v-if="item.targetJson">
                <template v-for="(targetJsonItem,targetJsonIndex) in JSON.parse(item.targetJson)">
                  <el-tooltip class="item" effect="dark" content="双击插入" placement="top-start"
                              :ref="targetJsonIndex" :key="targetJsonIndex">
                    <div class="item-content-target db-target"
                         :class="targetRightViewClass('tb-target')"
                         v-html="targetJsonItem.targetSent"
                         @dblclick="handlerdbtarget(targetJsonItem)">
                    </div>
                  </el-tooltip>
                </template>
              </template>
              <template v-else>
                <el-tooltip class="item" effect="dark" content="双击插入" placement="top-start">
                  <div class="item-content-target db-target"
                       :class="targetRightViewClass('tb-target')" v-html="item.targetSent"
                       @dblclick="handlerdbtarget(item)"></div>
                </el-tooltip>
              </template>
            </div>
            <div class="frangment-wrap-item-bottom">
              <div class="item-bottom-origin term-lib-name" :title="item.libName">
                来源:
                <span class="result-text">{{item.libName}}</span>
              </div>
            </div>
          </div>
        </template>
      </div>
      <!-- qa -->
      <div class="frangment-QA-wrap" v-if="!!(getFrangmentQAInfo&&getFrangmentQAInfo.length)">
        <div class="QA-title">QA错误</div>
        <div class="target-details">
          <span class="name">详情：</span>
          <span class="details-text" v-html="getFrangmentQAInfo[0].targetSent" />
        </div>
        <div class="QA-content">
          <ul class="QA-content-item QA-content-header">
            <li class="first">序号</li>
            <li class="second">错误描述</li>
            <li class="last">严重级别</li>
          </ul>
          <ul class="QA-content-item" v-for="(item,index) in getFrangmentQAInfo"
              :key="`${index}-${item.id}`"
              :class="{'QA-last-item':(getFrangmentQAInfo.length)===(index+1)}">
            <li class="first">{{(index+1).toString().padStart(2, '0')}}</li>
            <li class="second">{{(item.errorDesc) || '佚失'}}</li>
            <li class="last" :class="errLevelClass(item)">{{errLevel(item)}}</li>
          </ul>
        </div>
      </div>

      <!--批注-->
      <div class="suggest-remarks-wrap"
           v-if="!!(getFrangmentQAInfo&&getFrangmentQAInfo.length)&&getSuggestRemarksInfo">
        <el-form ref="formRemarks" :model="formRemarks" :rules="rules">
          <el-form-item class="remarks-content" prop="comment">
            <el-input type="textarea" v-model="formRemarks.comment" maxlength="50"
                      placeholder="请输入内容(最大长度50个字符)" @input="changeInput()" />
          </el-form-item>
          <el-form-item class="button-box">
            <el-row class="button-box-inside" :gutter="40">
              <el-col :span="12">
                <el-button type="primary" @click="()=>handleSubmitRemarks('formRemarks')">
                  通知
                </el-button>
              </el-col>
              <el-col :span="12">
                <el-button @click="()=>handleReset('formRemarks')">清空</el-button>
              </el-col>
            </el-row>
          </el-form-item>
        </el-form>
      </div>

    </el-col>
    <AddTerm :shown="shown" :termInfo="termInfo" @handleCancel="handleCancel" />
  </el-row>
</template>

<script>
import { mapGetters } from 'vuex';
import { highlight, trimSpace, findID, domArray } from "@/services/common";
import AddTerm from "@/components/layer/addTerm";
export default {
  name: "Suggest",
  components: { AddTerm },
  data() {
    return {
      SPECIAL_LANGUAGE: SPECIAL_LANGUAGE,
      number: 0,
      toolNumber: 0,
      entryKeyword: null,
      replaceKeyword: null,
      activeName: 'third',
      form: {
        source: null,
        target: null,
      },
      replaceItem: [],
      isFirst: true,
      nodesInfo: [],
      shown: false,
      termInfo: {},
      formRemarks: {
        comment: ''
      },
      remarkInfo: {},
      rules: {
        comment: [
          { required: true, message: '请填写备注信息', trigger: 'blur' }
        ]
      },
      status: true
    }
  },

  computed: {
    ...mapGetters('editor', [
      'getSuggestRemarksInfo',        // 获取翻译建议批注是否显示状态
      'getTempSentenceIdInfo',        // 获取临时句子信息
      'getUserInfo',                  // 用户信息
      'getProjectInfo',               // 项目信息
      'getUrlInfo',                   // 路由信息
      'getFileInfo',                  // 文件信息
      'getFileTaskInfo',              // 文件任务信息
      'getTaskContentList',           // 获取编辑器文件list
    ]),
    ...mapGetters({
      // 主题信息
      themeInfo: 'editor/getThemeInfo',
      // 获取单句机翻
      getFragmentSentenceMt: 'editor/fragmentSentenceMt',
      //获取片段的记忆库
      getFrangmentMemoryInfo: 'editor/getFragmentMemoryInfo',
      //获取片段的术语库
      getFrangmentTermInfo: 'editor/getFragmentTermInfo',
      //获取片段QA列表
      getFrangmentQAInfo: 'editor/getFragmentQAList'
    }),
    getEditorRightShownInfo: function () {
      const self = this;
      let editorShownInfo = JSON.parse(JSON.stringify(self.$store.getters['editor/getEditorRightShownInfo']));
     
      return editorShownInfo;
    },

    //获取主题
    getThemeInfo() {
      if (this.themeInfo === 'dark') {
        return 'suggest-inside-dark';
      } else if (this.themeInfo === 'eye-protection') {
        return 'suggest-inside-eye-protection'
      }
      return ''
    },

    //获取任务信息
    /**
     * @desc 是否禁用替换及全部替换
     * @return {boolean} result
     */
    isReplaceDisabled() {
      let result = null
      const { ifOnlyPreview } = this.getTaskContentList
      const { finish } = this.getCurrentfileInfo
      // 如果只能预览或者已经提交 则需要禁掉替换功能
      result = parseInt(ifOnlyPreview) === 0 && parseInt(finish) === 1
      console.log(result, 'result');
      return result
    },
    /**
     * @desc 获取判断后的文件信息或任务信息
     * @return {object} result 返回结果
     */
    getCurrentfileInfo() {
      let result = {}
      const { type } = this.getUrlInfo
      if (type === 'project') {
        result = this.getFileInfo
      } else if (['task', 'school'].includes(type)) {
        result = this.getFileTaskInfo
      }
      return result
    },
  },
  watch:{
    getEditorRightShownInfo(newVal,oldVal){
      if(oldVal.column === 'first'&& oldVal.hasOwnProperty('source')&&newVal.column != 'first'){
        console.log('变化了');
        this.entryKeyword = null;
        this.replaceKeyword = null;
        this.handleChange()
      }
      this.form = {
        source: newVal.sourceKeyword ,
        target: newVal.targetKeyword,
      };
    }
  },
  beforeDestroy() {
    console.log('卸载了');
      // 清空输入框的值
      this.entryKeyword = null;
      this.handleChange()
    },
  destroyed() {
    this.replaceKeyword = null;
    this.$store.dispatch("editor/setOerationSignInfo", {});
  },

  methods: {
    /**
  * @desc 特殊语种样式处理
  * @param {source} 源语言/目标语言
  * @returns {string} 返回样式类名
  */
    targetRightViewClass(source) {
      const type = source.split('-')[1]
      const { sourceLang, targetLang } = this.getUrlInfo
      if (type === 'source' && this.SPECIAL_LANGUAGE.indexOf(sourceLang) !== -1) {
        return 'right-view'
      } else if (type === 'target' && this.SPECIAL_LANGUAGE.indexOf(targetLang) !== -1) {
        return 'right-view'
      }
    },
    //获取句子信息
    async handlerdbtarget(item, types) {
      let cursorPositionTargetInfo = this.$store.getters["editor/getCursorPositionTargetInfo"];
      let tempAtom = Array()
      let tempStr = "";
      let $index = null;
      // 更新句子的参数
      const { type } = this.getUrlInfo;
      const { item: sentenceInfo, } = this.getTempSentenceIdInfo;
      const { id: taskId, taskType } = this.getCurrentfileInfo;
      const { status, templateKey, id, sourceTermSent, targetTermSent } = sentenceInfo;
      // 即将插入修改的句子原本的高亮术语词
      const highlightTerms = {}
      if (sourceTermSent && sourceTermSent.length) {
        highlightTerms.sourceTermSent = sourceTermSent
      }
      if (targetTermSent && targetTermSent.length) {
        highlightTerms.targetTermSent = targetTermSent
      }
      const info = {
        atomKey: templateKey,
        data: item.targetSent,
        dataType: 'text',
        id,
        sort: id.toString().substr(0, 5),
        style: '',
        tagType: 'text',
      }
      if (cursorPositionTargetInfo[3]) {
        $index = cursorPositionTargetInfo[3].index
      }

      if (cursorPositionTargetInfo[2] === "header") {
        let tagSourceSent = cursorPositionTargetInfo[1].tagSourceSent.atoms;
        tagSourceSent.splice($index, 0, info);
        tempAtom = [...cursorPositionTargetInfo[0].tagSourceSent.atoms, ...tagSourceSent];
      } else if (cursorPositionTargetInfo[2] === "middle") {
        // cursorPositionTargetInfo.pop();
        // cursorPositionTargetInfo.map((item, index) => {
        //   if (Reflect.has(item.tagSourceSent, "atoms") && !!item.tagSourceSent.atoms && !!item.tagSourceSent.atoms.length) {

        //     // return
        //     //   item.tagSourceSent.atoms.map(item2 => {
        //     //     tempAtom.push(item2);
        //     //   });
        //     // if (index === 0) {
        //     //   tempAtom.push(info);
        //     // }
        //     // tempAtom = [...]
        //   }
        // });
        let tagSourceSent = cursorPositionTargetInfo[0].tagSourceSent.atoms;
        tagSourceSent.push(info);
        tempAtom = [...tagSourceSent, ...cursorPositionTargetInfo[1].tagSourceSent.atoms];
      } else if (cursorPositionTargetInfo[2] === "tail" || !(!!cursorPositionTargetInfo[2])) {
        let tagSourceSent = cursorPositionTargetInfo[0].tagSourceSent.atoms;
        tagSourceSent.push(info);
        tempAtom = [...tagSourceSent, ...cursorPositionTargetInfo[1].tagSourceSent.atoms];
      }
      // console.log(tempAtom)
      // return
      tempAtom.forEach(item => {
        tempStr = `${tempStr}${item.data}`;
      })
      this.$nextTick(async () => {
        const params = {
          costTime: 0,
          taskId: type === 'project' ? null : taskId,
          taskType,
          fileId: type === 'project' ? this.getCurrentfileInfo.id : this.getCurrentfileInfo.fileId,
          content: tempStr,
          status,
          sentId: id,
          isSaveVersion: 0,
          isCommitVersion: 0,
          targetTagFragmentVo: {},
          sourceTagFragmentVo: null
        }
        const targetTagFragmentVo = {
          sort: 0,
          text: null,
          type: null,
          atoms: tempAtom
        }
        params.targetTagFragmentVo = targetTagFragmentVo
        if (!(['school', 'task'].includes(type))) {
          params.taskId = null
          params.taskType = null
        }
        let updataType = this.$store.getters['editor/getUpdataFragmentTypeInfo'] || 1;
        let editorBottomActiveNameInfo = this.$store.getters['editor/getEditorBottomActiveNameInfo'];
        const paramsInfo = {
          params,
          type: updataType,
          activeName: editorBottomActiveNameInfo,
          highlightTerms
        }
        const res = await this.$store.dispatch('editor/updateTargetInfo', paramsInfo);
        if (res) {
          this.$message.closeAll()
          this.$message.success('成功插入译文！')

        }
      })
    },
    /**
     * @desc 机翻、记忆库、术语库插入
     * @param {string} insertType AT|TM|TB 插入类型
     * @param {object} item 当前点击插入的数据
     */
    handleInsertTargetSentence(insertType, item) {
      const { type: sentenceType } = this.getTempSentenceIdInfo
      if (sentenceType !== 'target') {
        this.$message.closeAll()
        return this.$message.warning('请先点击需要插入的译文框')
      }
      let contentText = ''
      switch (insertType) {
        case 'AT':
          contentText = item.atoms.map(item => item.data).join('')
          this.updateSentence(contentText)
          break;
        case 'TM':
          this.updateSentence(item.targetSent)
          break;
        case 'TB':
          this.updateSentence(item.targetSent)
          break;

        default:
          break;
      }
    },
    /**
     * @desc 更新句子
     * @param {string} updateText 更新内容
     */
    async updateSentence(updateText) {
      const { type } = this.getUrlInfo;
      const { item: sentenceInfo, } = this.getTempSentenceIdInfo
      const { id: taskId, taskType } = this.getCurrentfileInfo
      const { status, templateKey, id, sourceTermSent, targetTermSent } = sentenceInfo
      // 即将插入修改的句子原本的高亮术语词
      const highlightTerms = {}
      if (sourceTermSent && sourceTermSent.length) {
        highlightTerms.sourceTermSent = sourceTermSent
      }
      if (targetTermSent && targetTermSent.length) {
        highlightTerms.targetTermSent = targetTermSent
      }
      // 更新句子的参数
      const params = {
        costTime: 0,
        taskId: type === 'project' ? null : taskId,
        taskType,
        fileId: type === 'project' ? this.getCurrentfileInfo.id : this.getCurrentfileInfo.fileId,
        content: updateText,
        status,
        sentId: id,
        isSaveVersion: 0,
        isCommitVersion: 0,
        targetTagFragmentVo: {},
        sourceTagFragmentVo: null
      }
      const targetTagFragmentVo = {
        sort: 0,
        text: null,
        type: null,
        atoms: []
      }
      const info = {
        atomKey: templateKey,
        data: updateText,
        dataType: 'text',
        id,
        sort: id.toString().substr(0, 5),
        style: '',
        tagType: 'text',
      }
      targetTagFragmentVo.atoms.push(info)
      params.targetTagFragmentVo = targetTagFragmentVo
      if (!(['school', 'task'].includes(type))) {
        params.taskId = null
        params.taskType = null
      }
      let updataType = this.$store.getters['editor/getUpdataFragmentTypeInfo'] || 1;
      let editorBottomActiveNameInfo = this.$store.getters['editor/getEditorBottomActiveNameInfo'];
      const paramsInfo = {
        params,
        type: updataType,
        activeName: editorBottomActiveNameInfo,
        highlightTerms
      }
      const res = await this.$store.dispatch('editor/updateTargetInfo', paramsInfo)
      if (res) {
        this.$message.closeAll()
        this.$message.success('成功插入译文！')
      }
    },


    changeInput(type) {
      if (type === 'source') {
        this.form.source = this.form.source.replace(/^\s*/g, '');
      } else if (type === 'target') {
        this.form.target = this.form.target.replace(/^\s*/g, '');
      } else {
        this.formRemarks.comment = this.formRemarks.comment.replace(/^\s*/g, '');
      }
    },
    //弹出关闭
    handleCancel() {
      this.shown = false;
      let oerationSignParams = {
        column:this.getEditorRightShownInfo.column,
        sourceKeyword:'',
        targetKeyword:''
      }
      this.$store.dispatch(
              "editor/setOerationSignInfo",
              oerationSignParams
            );
      this.form.source = ''
      this.form.target = ''
    },

    //错误级别
    errLevel(item) {
      if (!!item && !!(item.grade)) {
        switch (parseInt(item.grade)) {
          case 0:
            return '轻微错误';
          case 1:
            return '一般错误';
          case 2:
            return '严重错误';
          default:
            return '轻微错误';
        }
      } else {
        return '轻微错误';
      }
    },

    //错误级别
    errLevelClass(item) {
      if (!!item && !!(item.grade)) {
        switch (parseInt(item.grade)) {
          case 0:
            return 'slight-error';
          case 1:
            return 'commonly-error';
          case 2:
            return 'serious-error';
          default:
            return 'slight-error';
        }
      } else {
        return 'slight-error';
      }
    },

    //提交表单
    handleSubmit() {
      const self = this;
      self.$refs['form'].validate((valid) => {
        if (!valid) {
          return false
        }
        this.termInfo = {
          sourceSent: this.form.source,
          targetSent: this.form.target
        }
        this.shown = true



        // if (valid) {
        //   let params = Object();
        //   let roleLevel = 0;
        //   let fileId = 0;
        //   let urlInfo = self.$store.getters['editor/getUrlInfo'];
        //   if ((urlInfo.type) === 'project') {
        //     let fileInfo = self.$store.getters['editor/getFileInfo'];
        //     fileId = (fileInfo.id);
        //   } else if (((urlInfo.type) === 'task') || ((urlInfo.type) === 'school')) {
        //     let fileTaskInfo = self.$store.getters['editor/getFileTaskInfo'];
        //     fileId = (fileTaskInfo.fileId);
        //   }
        //   let userInfo = JSON.parse(localStorage.getItem('myUser'));
        //   if (userInfo && (userInfo.lastSelectCompany) && (userInfo.lastSelectCompany.role)) {
        //     roleLevel = userInfo.lastSelectCompany.role.roleLevel;
        //     Reflect.set(params, 'roleLevel', roleLevel);
        //   } else {
        //     self.$message({
        //       message: '获取用户信息失败,请稍后刷新重试.',
        //       type: 'warning'
        //     });
        //     return true
        //   }
        //   Reflect.set(params, 'fileId', fileId);
        //   Reflect.set(params, 'taskId', urlInfo.taskId);
        //   Reflect.set(params, 'sourceSent', (self.form.source));
        //   Reflect.set(params, 'targetSent', (self.form.target));
        //   self.$store.dispatch('editor/searchTermNumber', params).then((resp) => {
        //     let termInfo = Object();
        //     Reflect.set(termInfo, 'params', params);
        //     Reflect.set(termInfo, 'resp', resp);
        //     this.termInfo = termInfo;
        //     this.shown = true;
        //   })
        // } else {
        //   return false;
        // }
      });
    },

    //提交批注
    handleSubmitRemarks(formName) {
      const self = this;
      let urlInfo = self.$store.getters['editor/getUrlInfo'];
      let tempSentenceInfo = self.$store.getters['editor/getTempSentenceIdInfo'];
      self.$refs[formName].validate((valid) => {
        let params = Object();
        if (!!tempSentenceInfo && !!(tempSentenceInfo.item)) {
          Reflect.set(params, 'commentType', 3);
          Reflect.set(params, 'comment', (self.formRemarks.comment));
          Reflect.set(params, 'transFileId', (urlInfo.fileId));
          Reflect.set(params, 'taskId', (urlInfo.taskId));
          Reflect.set(params, 'sentId', (tempSentenceInfo.item.id));
          Reflect.set(params, 'sourceSent', (tempSentenceInfo.item.sourceSent));
          Reflect.set(params, 'commentSent', (tempSentenceInfo.item.sourceSent));
          Reflect.set(params, 'commentIndex', (tempSentenceInfo.item.sourceWordNum));
          if (valid) {
            self.$store.dispatch('editor/setFragmentInfo', params).then((res) => {
              if (res) {
                self.$message({
                  message: '通知成功',
                  type: 'success'
                });
                self.handleReset('formRemarks');
              } else {
                self.$message({
                  message: '通知失败',
                  type: 'warning'
                });
              }
            });
          } else {
            return false;
          }
        }
      });
    },

    //取消添加术语--重置表单
    handleReset(form) {
      this.$refs[form].resetFields();
      let params = {
          column: "second",
          sourceKeyword:'',
          targetKeyword:'',
        };
      this.$store.dispatch("editor/setOerationSignInfo", params);
    },

    getNodeInfo() {
      let dom = Array.from((document.getElementById('editorBox')).querySelectorAll(`div[type]`));
      if (!!dom) {
        this.nodesInfo = dom
      }
    },

    //查找替换--需要商定更好的解决方式
    handleChange( e, index = 0) {
      const self = this;
      this.number = 0//重置number
      let value
      e ? value = e.target.value : value = self.entryKeyword
      // let value = self.entryKeyword
      // let value = (e.target.value);
      let domInfo = this.getTaskContentList.transSentRespVoList;
      let replaceItem = Array();
      // self.entryKeyword = (e.target.value);
      domInfo.forEach((item) => {
        let SourceSent = JSON.parse(item.tagSourceSent);
        let TargetSent = (item.tagTargetSent) === "" ? (item.tagTargetSent) : JSON.parse(item.tagTargetSent);
        //处理原始语言  (原文)
        if (!!SourceSent && !!(SourceSent.fragments) && !!(SourceSent.fragments[0]) && (SourceSent.fragments[0].atoms)) {
          (SourceSent.fragments[0].atoms).forEach((sourceItem) => {
            //对数据代理临时处理在进行更新
            if (!!(sourceItem.data) && sourceItem.dataType !== "tag") {
              let replaceInfo = (highlight(value, (sourceItem.data), item, 'source'));
              if (Reflect.has(replaceInfo, 'item')) {
                replaceItem.push(replaceInfo.item)
              }
              Reflect.set(sourceItem, 'dataHTML', (replaceInfo.resultsList));
              Reflect.set(sourceItem, 'searchState', true);
            }
          });
          Reflect.set(item, 'tagSourceSent', JSON.stringify(SourceSent))
        }
        //处理目标语言 (译文)
        if (!!TargetSent && !!(TargetSent.fragments) && !!(TargetSent.fragments[0]) && (TargetSent.fragments[0].atoms)) {
          (TargetSent.fragments[0].atoms).forEach((targetItem) => {
            if (!!(targetItem.data) && targetItem.dataType !== "tag") {
              let replaceInfo = (highlight(value, (targetItem.data), item, 'target'));
              if (Reflect.has(replaceInfo, 'item')) {
                replaceItem.push(replaceInfo.item)
              }
              Reflect.set(targetItem, 'dataHTML', (replaceInfo.resultsList));
              Reflect.set(targetItem, 'searchState', true);
            }
          });
          Reflect.set(item, 'tagTargetSent', JSON.stringify(TargetSent))
          // console.log(document.getElementById(`target-${item.id}`).querySelector(`[type="heightArea"]`))
        }
      });
      self.$nextTick(() => {
        let domHeight = document.getElementsByClassName('hightLight');
        self.toolNumber = domHeight.length;
        if (!!(domHeight.length)) {
          domHeight[`${index}`].style.background = 'rgba(253,149,61)'
        }
      });
      // console.log(replaceItem)
      self.replaceItem = replaceItem;
      // console.log(self.replaceItem);


    },

    //查找上一个
    handlePrev() {
      let domHeight = document.getElementsByClassName('hightLight');
      let index = --(this.number);
      if (!!(domHeight.length) && (index >= 0)) {
        domHeight[`${index}`].style.background = 'rgba(253,149,61)';
        this.number = index;
        domHeight[`${index + 1}`].style.background = null;
        let wrapper = domHeight[`${index}`]
        wrapper.scrollIntoView();
      } else {
        this.$message({
          message: '已经是第一条',
          type: 'warning'
        });
        this.number = ++(this.number);
      }
    },

    //查找下一个
    handleNext() {
      let domHeight = document.getElementsByClassName('hightLight');
      // console.log(domHeight)
      let index = ++(this.number);
      if (!!(domHeight.length) && (((domHeight.length) - 1) >= index)) {
        domHeight[`${index}`].style.background = 'rgba(253,149,61)';
        this.number = index;
        domHeight[`${index - 1}`].style.background = null;
        let wrapper = domHeight[`${index}`]
        wrapper.scrollIntoView();
      } else {
        this.$message({
          message: '已经是最后一条',
          type: 'warning'
        });
        this.number = --(this.number);
      }
    },

    //替换的关键字
    handleKeyword(e) {
      this.replaceKeyword = (e.target.value);
    },

    //单独替换
    handleReplace() {
      const self = this;
      // self.handleChange();
      if ((self.entryKeyword) && (self.replaceKeyword) && ((self.entryKeyword) !== (self.replaceKeyword)) && !!(self.replaceItem.length)) {
        self.Generator((self.number));
      } else {
        self.$message({
          message: '请先输入要替换的词或者查找词和替换词相同',
          type: 'warning'
        });
      }
    },

    //单独替换的执行函数
    Generator(items) {
      const self = this;
      let eleArr = document.getElementsByClassName('hightLight');
      if (!!eleArr && !!(eleArr.length) && ((eleArr.length) > items)) {
        let currentEle = eleArr[`${items}`];
        // 父节点自定义属性[] 例：['source', '6115081264', '1']
        let currentFragmentInfo = findID(currentEle);
        // 文件list参数 
        const { transSentRespVoList } = this.getTaskContentList
        if (transSentRespVoList && transSentRespVoList.length) {
          let transList = transSentRespVoList;
          transList.every((item) => {
            if (parseInt(item.id) === parseInt(currentFragmentInfo[1])) {
              currentEle.innerText = (self.replaceKeyword);
              currentEle.removeAttribute('style');
              currentEle.classList.remove('hightLight');
              let currentFragment = document.getElementById(`${currentFragmentInfo[0]}-${item.id}`);
              let childrenNodeAll = (currentFragment.childNodes);
              let info = domArray(childrenNodeAll, item, Array());

              let params = Object();
              if (!!info && !!(info.length)) {
                let content = '';
                info.forEach((AtomsItem, index) => {
                  if ((AtomsItem.dataType) !== 'tag') {
                  }
                  // content = `${trimSpace(content)}${trimSpace(AtomsItem.data)}`;
                  content = `${(content)}${(AtomsItem.data)}`;
                });
                Reflect.set(params, 'content', content);
              }
              let fileId = null;
              let taskId = null;
              let taskType = null;
              const { type } = this.getUrlInfo
              if (type === 'project') {
                fileId = this.getFileInfo.id;
              } else if (type === 'task' || type === 'school') {
                fileId = this.getFileTaskInfo.fileId;
                taskId = this.getFileTaskInfo.id;
                taskType = this.getFileTaskInfo.taskType;
              }
              Reflect.set(params, 'fileId', fileId);
              Reflect.set(params, 'taskId', taskId);
              Reflect.set(params, 'taskType', taskType);
              Reflect.set(params, 'isCommitVersion', 0);
              Reflect.set(params, 'isSaveVersion', 1);
              Reflect.set(params, 'costTime', 0);
              Reflect.set(params, 'status', (item.status));
              Reflect.set(params, 'sentId', currentFragmentInfo[1]);
              console.log(currentFragmentInfo, "33333")
              if ((currentFragmentInfo[0] === 'source')) {
                let sourceTagFragmentVo = Object();
                Reflect.set(sourceTagFragmentVo, 'atoms', info);
                Reflect.set(sourceTagFragmentVo, 'sort', 0);
                Reflect.set(sourceTagFragmentVo, 'text', null);
                Reflect.set(sourceTagFragmentVo, 'type', null);
                Reflect.set(params, 'sourceTagFragmentVo', sourceTagFragmentVo);
                Reflect.set(params, 'targetTagFragmentVo', null);
              }
              if ((currentFragmentInfo[0] === 'target')) {
                let targetTagFragmentVo = {};
                Reflect.set(targetTagFragmentVo, 'atoms', info);
                Reflect.set(targetTagFragmentVo, 'sort', 0);
                Reflect.set(targetTagFragmentVo, 'text', null);
                Reflect.set(targetTagFragmentVo, 'type', null);
                Reflect.set(params, 'sourceTagFragmentVo', null);
                Reflect.set(params, 'targetTagFragmentVo', targetTagFragmentVo);
              }
              let paramsInfo = {};
              Reflect.set(paramsInfo, 'params', params);
              Reflect.set(paramsInfo, 'type', 4);
              Reflect.set(paramsInfo, 'langType', currentFragmentInfo[0]);
              Reflect.set(paramsInfo, 'keyword', (self.entryKeyword));
              self.$store.dispatch('editor/updateTargetInfo', paramsInfo).then((resp) => {
                if (resp) {
                  let info = JSON.parse(self.replaceItem[0].tagTargetSent)
                  info.fragments[0].atoms[0].data = params.content
                  self.replaceItem[0].tagTargetSent = JSON.stringify(info)
                  // console.log(self.replaceItem, "self.replaceItem");
                  let domHeight = document.getElementsByClassName('hightLight');
                  if (!!(domHeight.length)) {
                    let toolNumber = parseInt(domHeight.length);
                    let index = parseInt(self.number);
                    self.toolNumber = toolNumber;
                    if ((toolNumber > index)) {
                      domHeight[`${parseInt(self.number)}`].style.background = 'rgba(253,149,61)';
                    } else if ((toolNumber === index)) {
                      self.number = toolNumber - 1;
                      domHeight[`${parseInt(self.number)}`].style.background = 'rgba(253,149,61)';
                    }
                  } else {
                    self.toolNumber = 0;
                    self.replaceItem = Array();
                  }
                }
              });
              // } else {
              //   self.handleNext()
              // }
              return false
            } else {
              return true
            }
          })
        }
      }
    },


    //全部替换
    async handleAllReplace() {
      const self = this;
      let fileId = 0;
      const { type } = this.getUrlInfo
      fileId = this.getFileInfo.id;
      //替换更新
      if ((self.entryKeyword) && (self.replaceKeyword) && ((self.entryKeyword) !== (self.replaceKeyword)) && !!(self.replaceItem.length)) {
        let paramsList = self.replaceItem.map((item) => {
          if (!!(item.tagSourceSent) || !!(item.tagTargetSent)) {
            let params = Object();
            let tagSourceSent = JSON.parse(item.tagSourceSent);
            let tagTargetSent = (item.tagTargetSent) === "" ? (item.tagTargetSent) : JSON.parse(item.tagTargetSent);
            //修改的源语言
            if ((item.type === 'source')) {
              if (!!tagSourceSent && !!(tagSourceSent.fragments) && !!(tagSourceSent.fragments[0]) && !!(tagSourceSent.fragments[0].atoms)) {
                let content = '';
                let atoms = (tagSourceSent.fragments[0].atoms);
                atoms.map((item2) => {
                  // 匹配关键字正则
                  Reflect.deleteProperty(item2, 'dataHTML');
                  Reflect.deleteProperty(item2, 'searchState');
                  let replaceReg = new RegExp((self.entryKeyword), 'g');
                  if (item2.dataType !== "tag") {
                    Reflect.set(item2, 'data', (item2.data).replace(replaceReg, (self.replaceKeyword)));
                    content = trimSpace(`${content}${item2.data}`);
                  }
                });
                if (content) {
                  Reflect.set(tagSourceSent, 'content', content);
                }
                Reflect.set(tagSourceSent, 'fragments', atoms);
              }
            }
            //修改的目标语言
            if ((item.type === 'target')) {
              if (!!tagTargetSent && !!(tagTargetSent.fragments) && !!(tagTargetSent.fragments[0]) && !!(tagTargetSent.fragments[0].atoms)) {
                let content = '';
                let atoms = (tagTargetSent.fragments[0].atoms);
                atoms.map((item2) => {
                  // 匹配关键字正则
                  Reflect.deleteProperty(item2, 'dataHTML');
                  Reflect.deleteProperty(item2, 'searchState');
                  let replaceReg = new RegExp((self.entryKeyword), 'g');
                  if (item2.dataType !== "tag" && !!item2.data) {
                    Reflect.set(item2, 'data', (item2.data).replace(replaceReg, (self.replaceKeyword)));
                    content = trimSpace(`${content}${item2.data}`);
                  }
                });
                if (!!content) {
                  Reflect.set(tagTargetSent, 'content', content);
                }
                Reflect.set(tagTargetSent, 'fragments', atoms);
              }
            }
            Reflect.set(params, 'constTime', 0);
            Reflect.set(params, 'taskId', null);
            Reflect.set(params, 'taskType', null);
            Reflect.set(params, 'isSaveVersion', 1);
            Reflect.set(params, 'sentId', (item.id));
            Reflect.set(params, 'status', (item.status));
            Reflect.set(params, 'fileId', fileId);
            if ((item.type === 'source')) {
              let sourceTagFragmentVo = Object();
              Reflect.set(sourceTagFragmentVo, 'atoms', (tagSourceSent.fragments));
              Reflect.set(params, 'sourceTagFragmentVo', sourceTagFragmentVo);
              Reflect.set(params, 'targetTagFragmentVo', null);
              Reflect.set(params, 'content', (tagSourceSent.content));
            }
            if ((item.type === 'target')) {
              let targetTagFragmentVo = Object();
              Reflect.set(targetTagFragmentVo, 'atoms', (tagTargetSent.fragments));
              Reflect.set(params, 'sourceTagFragmentVo', null);
              Reflect.set(params, 'targetTagFragmentVo', targetTagFragmentVo);
              Reflect.set(params, 'content', (tagTargetSent.content));
            }
            self.toolNumber = (self.replaceItem).length;
            let paramsInfo = Object();
            Reflect.set(paramsInfo, 'params', params);
            Reflect.set(paramsInfo, 'type', 4);
            return paramsInfo
          }
        }).filter(item => Boolean(item))
        if (paramsList.length) {
          for (const param of paramsList) {
            await this.$store.dispatch('editor/updateTargetInfo', param)
          }
        }
        self.toolNumber = 0;
        self.replaceItem = Array();
        self.status = true;
      } else {
        self.$message({
          message: `查找词或者替换词不可为空、查无结果、查找词和替换词相同`,
          type: "error"
        });
      }
    },

  }
}
</script>

<style lang="less" scoped>
@import "./assets/style.less";
</style>